module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/xk-48269c0b55c2532ccb7608a0fc28a5c2.svg";